<!-- <div class="toast-container position-fixed bottom-0 end-0 p-3" style="z-index:1080">
  <div
    *ngFor="let t of toastSvc.queue()"
    class="toast show text-white bg-{{ t.variant }} border-0 mb-2"
    role="alert"
    (click)="toastSvc.dismiss(t.id)"
  >
    <div class="toast-body">{{ t.text }}</div>
  </div>
</div>
 -->


<!-- <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1080">
  <div
    *ngFor="let t of toastSvc.queue()"
    class="toast-box {{ t.variant }}"
    role="alert"
    (click)="toastSvc.dismiss(t.id)"
  >
    <ng-container *ngIf="t.iconType === 'emoji'; else imageIcon">
      <div class="toast-icon">{{ t.icon || getIcon(t.variant) }}</div>
    </ng-container>
    <ng-template #imageIcon>
      <img [src]="t.icon || getDefaultIcon(t.variant)" alt="icon" class="toast-icon" />
    </ng-template>

    <div class="toast-text">
      <div *ngIf="t.title" class="toast-title">{{ t.title }}</div>
      <div class="toast-message">{{ t.text }}</div>
    </div>
  </div>
</div> -->


<div class="toast-container position-fixed" style="z-index: 1080">
  <div
    *ngFor="let t of toastSvc.queue()"
    class="toast-box d-flex align-items-start position-relative"
    [ngClass]="t.variant"
    role="alert"
  >
    <!-- Icon -->
    <div class="toast-icon me-2">
      <ng-container *ngIf="t.iconType === 'emoji'; else imageIcon">
        {{ t.icon || getIcon(t.variant) }}
      </ng-container>
      <ng-template #imageIcon>
        <img
          [src]="t.icon || getDefaultIcon(t.variant)"
          alt="icon"
          class="toast-icon-img"
          width="24"
          height="24"
        />
      </ng-template>
    </div>

    <!-- Content -->
    <div class="toast-text flex-grow-1">
      <div *ngIf="t.title" class="toast-title">{{ t.title }}</div>
      <div class="toast-message">{{ t.text }}</div>
    </div>

    <!-- Close icon -->
   <button
      type="button"
      class="toast-close position-absolute"
      (click)="dismiss(t.id); $event.stopPropagation()"
      aria-label="Close"
      style="cursor: pointer;"
    >
      ×
    </button>
  </div>
</div>

